import { useEffect, useState } from "react";
import { X, Smartphone } from "lucide-react";
import { isAndroidApp } from "@/lib/twa";
import { PLAY_STORE_WEB } from "@/lib/rate";

const DISMISS_KEY = "aw_getapp_dismissed";

// Official "Get it on Google Play" badge — links to the live listing.
// Hidden when already running inside the installed Android app.
export const GooglePlayBadge = ({ height = 44, className = "" }) => {
  if (isAndroidApp()) return null;
  return (
    <a
      href={PLAY_STORE_WEB}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="google-play-badge"
      aria-label="Get Air Wave on Google Play"
      className={`inline-block shrink-0 transition-transform hover:scale-105 ${className}`}
    >
      <img src="/google-play-badge.png" alt="Get it on Google Play" style={{ height }} className="w-auto" />
    </a>
  );
};

// Slim, dismissible "Now on Google Play" strip for the Browse page.
export const AppInstallBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (isAndroidApp()) return;
    try {
      if (localStorage.getItem(DISMISS_KEY) === "1") return;
    } catch (_) {}
    setShow(true);
  }, []);
  if (!show) return null;
  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch (_) {}
    setShow(false);
  };
  return (
    <div
      data-testid="app-install-banner"
      className="relative mb-6 flex items-center gap-4 overflow-hidden rounded-2xl border border-[#00FFC2]/20 bg-gradient-to-r from-[#00FFC2]/10 to-[#FF0055]/10 px-4 py-3 sm:px-6"
    >
      <div className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-[#00FFC2]/15 text-[#00FFC2]">
        <Smartphone size={22} />
      </div>
      <div className="min-w-0 flex-1">
        <p className="font-display text-base font-bold leading-tight text-white">Air Wave is now on Google Play</p>
        <p className="truncate text-sm text-white/60">Install the app for the full-screen, faster experience.</p>
      </div>
      <GooglePlayBadge height={40} className="hidden sm:inline-block" />
      <a
        href={PLAY_STORE_WEB}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="app-install-cta"
        className="rounded-full bg-[#00FFC2] px-4 py-2 text-sm font-bold text-black transition-transform hover:scale-105 sm:hidden"
      >
        Get the app
      </a>
      <button
        onClick={dismiss}
        data-testid="app-install-dismiss"
        aria-label="Dismiss"
        className="grid h-7 w-7 shrink-0 place-items-center rounded-full text-white/40 transition-colors hover:bg-white/10 hover:text-white"
      >
        <X size={16} />
      </button>
    </div>
  );
};
